module.exports = __webpack_public_path__ + "img/oaFlowData202@3x.65177842.png";